export default __webpack_public_path__ + "929cada17ff7be3ec80415587b4dd7b3.webp";